import React, { useState, useEffect, useRef } from "react";
import { LanguageService } from "../../services/languageService";
import Slider from "react-input-slider";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, Pagination, Autoplay } from "swiper/modules";

import audios from "./../../asset/Music/audio";
import { storekit, storekit2 } from "./../../asset/Storekit/storekit";
import {
  Android,
  Android_en,
  Apk,
  Apk_en,
  BG_CD,
  CD,
  Ios,
  Ios_en,
  line,
  line_en,
  PC,
  PC_en,
  Play_video,
  next_music,
  pause,
  play,
  pre_music,
  Title,
  Title1,
  Title1_en,
  Title2,
  Title2_en,
  Title_en,
  logo,
} from "../../asset/images";
import "./main.scss";

const swiperPerson = {
  modules: [Navigation, Thumbs, Pagination],
  pagination: true,
  loop: true,
  rewind: true,
  speed: 600,
  grabCursor: true,
  navigation: true,
};

const swiperPerson2 = {
  modules: [Pagination, Autoplay],
  pagination: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  slidesPerView: 3,
  loop: true,
  rewind: true,
};

const sliderStyles = {
  track: { backgroundColor: "#fce9bb", height: "10px" },
  active: { backgroundColor: "#7a2a1b", height: "10px" },
  thumb: {
    marginTop: "-1px",
    width: "15px",
    height: "15px",
    backgroundColor: "#7a2a1b",
  },
};

const Main = () => {
  const [showIOSAlert, setShowIOSAlert] = useState(false);

  const handleIOSClick = (e) => {
    e.preventDefault();
    setShowIOSAlert(true);
  };
  const audioRef = useRef(null);
  const [audioIndex, setAudioIndex] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlay, setPlay] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const videoStorekit = storekit;
  const storekitData = storekit2;

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  const handleLoadedData = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
      // Đồng bộ giá trị slider ban đầu với thời gian hiện tại của audio
      setSliderValue(audioRef.current.currentTime);
      if (isPlay) {
        audioRef.current.play();
      }
    }
  };

  const handlePausePlayClick = () => {
    if (audioRef.current) {
      if (isPlay) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setPlay((prev) => !prev);
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef.current && !isDragging) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleAudioEnded = () => setPlay(false);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load();
      setCurrentTime(0);
      setSliderValue(0);
      if (isPlay) {
        audioRef.current.play();
      }
    }
  }, [audioIndex]);

  const handlePrevTrack = () => {
    setAudioIndex((prev) => (prev - 1 + audios.length) % audios.length);
  };

  const handleNextTrack = () => {
    setAudioIndex((prev) => (prev + 1) % audios.length);
  };

  const lang = LanguageService.detectLanguage();
  const translations = LanguageService.getTranslations();
  const links = LanguageService.getLinks();
  const imageSet = {
    title: lang === "vi" ? Title : Title_en,
    title1: lang === "vi" ? Title1 : Title1_en,
    title2: lang === "vi" ? Title2 : Title2_en,
    line: lang === "vi" ? line : line_en,
    android: lang === "vi" ? Android : Android_en,
    apk: lang === "vi" ? Apk : Apk_en,
    ios: lang === "vi" ? Ios : Ios_en,
    pc: lang === "vi" ? PC : PC_en,
  };

  return (
    <div className="Main container">
      <div className="Main__logo">
        <img src={logo} alt="Logo" />
      </div>
      {/* List Video */}
      <div className="list__video">
        <div className="title">
          <img src={imageSet.title} alt="title/listvideo" />
        </div>
        <div className="list">
          <Swiper {...swiperPerson}>
            {videoStorekit.map((item, index) => (
              <SwiperSlide key={`video-${index}`}>
                <div className="list__a">
                  <img
                    className="video__img"
                    src={lang === "vi" ? item?.tag : item?.tag_en}
                    alt={`video-${index}`}
                  />
                  <a className="video" href={links.fanpage} target="_blank">
                    <img className="video__phay" src={Play_video} alt="" />
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* List Storekit */}
      <div className="list__storikit">
        <div className="title">
          <img src={imageSet.title1} alt="title/liststorikit" />
        </div>
        <div className="list">
          <div className="pc">
            {storekitData.map((item, index) => (
              <div className="list__a" key={`storekit-pc-${index}`}>
                <img
                  src={lang === "vi" ? item?.tag : item?.tag_en}
                  alt={`storekit-pc-${index}`}
                />
              </div>
            ))}
          </div>
          <div className="mobile">
            <Swiper {...swiperPerson2}>
              {storekitData.map((item, index) => (
                <SwiperSlide key={`storekit-mobile-${index}`}>
                  <div className="list__a">
                    <img
                      src={lang === "vi" ? item?.tag : item?.tag_en}
                      alt={`storekit-mobile-${index}`}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>

      {/* List Music */}
      <div className="list__music">
        <div className="title">
          <img src={imageSet.title2} alt="title/listmusic" />
        </div>
        <div className="list">
          <div className="bg">
            <img src={BG_CD} alt="BG_CD" />
          </div>
          <div className="cd">
            <img
              className={
                isPlay
                  ? "site-animation-rotateRight"
                  : "site-animation-rotateRight-pause"
              }
              src={CD}
              alt="cd"
            />
          </div>
          <div className="thumbnail">
            <img src={audios[audioIndex].thumbnail} alt="thumbnail" />
          </div>

          <div className="time-display">
            <span>{formatTime(isDragging ? sliderValue : currentTime)}</span>
            <div className="song">
              <div className="Control-Button-Group">
                <div className="Prev-Button" onClick={handlePrevTrack}>
                  <img src={pre_music} alt="previous track" />
                </div>
                <div
                  className="Pause-Play-Button"
                  onClick={handlePausePlayClick}
                >
                  <img src={isPlay ? play : pause} alt="play/pause" />
                </div>
                <div className="Next-Button" onClick={handleNextTrack}>
                  <img src={next_music} alt="next track" />
                </div>
              </div>
              <Slider
                axis="x"
                x={isDragging ? sliderValue : currentTime}
                xmin={0}
                xmax={duration || 100}
                onChange={({ x }) => setSliderValue(x)}
                onDragStart={() => setIsDragging(true)}
                onDragEnd={() => {
                  // Kiểm tra sliderValue có phải số hợp lệ không
                  const newTime = Number.isFinite(sliderValue)
                    ? sliderValue
                    : 0;
                  if (audioRef.current) {
                    audioRef.current.currentTime = newTime;
                  }
                  setCurrentTime(newTime);
                  setIsDragging(false);
                }}
                style={{ width: "100%" }}
                styles={sliderStyles}
              />
              <audio
                ref={audioRef}
                src={audios[audioIndex].src}
                onLoadedData={handleLoadedData}
                onTimeUpdate={handleTimeUpdate}
                onEnded={handleAudioEnded}
              />
            </div>
            <span>{formatTime(duration)}</span>
          </div>
        </div>
        <div className="line">
          <img src={imageSet.line} alt="line" />
        </div>
        <div className="nav_menu__button">
          <ul className="nav_menu__button__bar">
            <a
              className="ten__hover"
              //onClick={handleIOSClick}
              href={links.ios}
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.ios} alt="ios" />
              </li>
            </a>
            <a
              className="ten__hover"
              //onClick={handleIOSClick}
              href={links.android}
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.android} alt="android" />
              </li>
            </a>
            <a
              className="ten__hover"
              //onClick={handleIOSClick}
              href={links.apk}
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.apk} alt="apk" />
              </li>
            </a>
            <a
              className="ten__hover"
              href={links.pc}
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.pc} alt="pc" />
              </li>
            </a>
          </ul>
        </div>
      </div>
      {showIOSAlert && (
        <div className="custom-alert-overlay">
          <div className="custom-alert">
            <p>{translations.message} </p>
            <button onClick={() => setShowIOSAlert(false)}>
              {translations.closeButton}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Main;
